import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

export default function Navigation() {
  const location = useLocation();

  return (
    <nav className="w-full bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-[#E5E0D8]">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="hover:opacity-80 transition-opacity outline-none">
          <Logo iconSize="w-5 h-5" textSize="text-xl" />
        </Link>
        
        <div className="flex items-center gap-6">
          <Link 
            to="/" 
            className={`text-xs font-semibold uppercase tracking-widest transition-colors ${
              location.pathname === '/' ? 'text-[#2C2A29]' : 'text-[#8A847A] hover:text-[#2C2A29]'
            }`}
          >
            Home
          </Link>
          <Link 
            to="/directory" 
            className={`text-xs font-semibold uppercase tracking-widest transition-colors ${
              location.pathname === '/directory' ? 'text-[#2C2A29]' : 'text-[#8A847A] hover:text-[#2C2A29]'
            }`}
          >
            Directory
          </Link>
        </div>
      </div>
    </nav>
  );
}